import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { Store } from './Store';
import { createModalSlice } from './slices/modalSlice';
import { createSidebarSlice } from './slices/sidebarSlice';
import { createThemeSlice } from './slices/themeSlice';

const SIDEBAR_OVERLAY_BREAKPOINT_PX = 768;

export function shouldRestoreSidebarOpen(persistedIsOpen: boolean): boolean {
  if (!persistedIsOpen) return false;
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= SIDEBAR_OVERLAY_BREAKPOINT_PX;
}

export const useStore = create<Store>()(
  devtools(
    immer(
      persist(
        (...params) => ({
          modal: createModalSlice(...params),
          sidebar: createSidebarSlice(...params),
          theme: createThemeSlice(...params),
        }),
        {
          name: 'clickersphere',
          partialize: (state) => ({
            sidebarIsOpen: state.sidebar.isOpen,
            themeMode: state.theme.mode,
          }),
          merge: (persistedState, currentState) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const persisted = persistedState as any;
            return {
              ...currentState,
              sidebar: {
                ...currentState.sidebar,
                isOpen: shouldRestoreSidebarOpen(!!persisted?.sidebarIsOpen),
              },
              theme: {
                ...currentState.theme,
                mode: persisted?.themeMode ?? 'system',
              },
            };
          },
        },
      ),
    ),
    {
      enabled: import.meta.env.DEV,
    },
  ),
);
